import { render, staticRenderFns } from "./uploadMaterial.vue?vue&type=template&id=515a661e&scoped=true"
import script from "./uploadMaterial.vue?vue&type=script&lang=js"
export * from "./uploadMaterial.vue?vue&type=script&lang=js"
import style0 from "./uploadMaterial.vue?vue&type=style&index=0&id=515a661e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "515a661e",
  null
  
)

export default component.exports